var en_AU_ocker = {};
module['exports'] = en_AU_ocker;
en_AU_ocker.title = "English (Australia Ocker)";
en_AU_ocker.name = require("./name");
en_AU_ocker.company = require("./company");
en_AU_ocker.internet = require("./internet");
en_AU_ocker.address = require("./address");
en_AU_ocker.phone_number = require("./phone_number");
